import { render, staticRenderFns } from "./list-card.vue?vue&type=template&id=5055a12c&scoped=true"
import script from "./list-card.vue?vue&type=script&lang=js"
export * from "./list-card.vue?vue&type=script&lang=js"
import style0 from "./list-card.vue?vue&type=style&index=0&id=5055a12c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5055a12c",
  null
  
)

export default component.exports